import React,{useRef,useState,useEffect} from 'react'
import './index.css'
import Switch from '@mui/material/Switch';
import * as moment from 'moment'
  import Files from './Files/files.js'
  import KycProfile from './KycProfile/kycProfile.js';
  import CreditProfile from './CreditProfile/CreditProfile.js';
  import IncomeProfile from './IncomeProfile/incomeProfile.js';
  import AccountAggregator from './IncomeProfile/accountAggregator.js';
  import LayoutFlow from '../MindMap/MindMap.js';
  import PreScreen from './Pre-Screen/preScreen.js';
  import { useCurrentUser } from '../../hooks/useCurrentUser';
  import { useMemo } from 'react';
  import MonkCibilAi from './MonkAi/MonkAi.js';
  import NotificationReport from './NotificationReport/notificationReport.js';
  import DisbursementModal from '../DisbursementModal/DisbursementModal';
  import {
    ReactFlowProvider,
  } from 'reactflow';
  import {
    Col,
    Card,
    Dropdown,
    DropdownItem,
    DropdownToggle,
    DropdownMenu,
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Row,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Input,
    Label,
  } from 'reactstrap';
  import { 
    DialogTitle, 
    DialogActions, 
    Grid, 
    MenuItem, 
    Select, 
    FormControl, 
    Divider ,Button, IconButton
  } from '@mui/material';
  import {  Box, Tab, Tabs, TextField,Typography, CircularProgress } from '@mui/material';
  import {useLocation,useNavigate,useSearchParams} from 'react-router-dom';
  import {useSelector,useDispatch} from 'react-redux'
  import {userActions} from '../../actions/user.actions';
  import axiosInstance from '../../helpers/axios';
  import WhatsAppIcon from '@mui/icons-material/WhatsApp';
  import Dialog from "@mui/material/Dialog";
  import DialogContent from "@mui/material/DialogContent";
  import Slide from "@mui/material/Slide";
  import ActivityLogo from "../../assets/images/activity.png";
  import Activity from '../Activity/Activity'
  import pencil from '../../assets/images/pencil.png'
  import LoanDetails from './LoanDetails/LoanDetails.jsx';  
  import MaleImg from "../../assets/images/male.png";
  import FemaleImg from "../../assets/images/female.png";
  import ContactSlider from './ContactSlider .js';
  import info from "../../assets/images/info.png";
  import Tooltip from '@mui/material/Tooltip';
  import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
  import todoDot from '../../assets/images/todoDot.png';
  import initiatedDot from '../../assets/images/initiatedDot.png';
  import activeDot from '../../assets/images/activeDot.png';
  import closedDot from '../../assets/images/closedDot.png';
  import pendingDot from '../../assets/images/pendingDot.png';
  import { IdCard, Camera, FileSignature, Landmark, ShieldAlert } from 'lucide-react';
  import IntegrationModals from '../IntegrationModals/IntegrationModals';
  import MoveReviewStatus from '../status/MoveReviewStatus/MoveReviewStatus';
  import MoveProcessingStatus from '../status/MoveProcessingStatus/MoveProcessingStatus';
  import MovePendingStatus from '../status/MovePendingStatus/MovePendingStatus';
  import MoveSanctionStatus from '../status/MoveSanctionStatus/MoveSanctionStatus';
  import MoveDisbursementStatus from '../status/MoveDisbursementStatus/MoveDisbursementStatus';
  import MoveRejectedStatus from '../status/MoveRejectedStatus/MoveRejectedStatus';
  import MoveOnHoldStatus from '../status/MoveOnHoldStatus/MoveOnHoldStatus';
  import MoveDroppedStatus from '../status/MoveDroppedStatus/MoveDroppedStatus';
  import MoveStatus from '../status/MoveStatus/MoveStatus';
  import EditForm from '../status/EditForm/EditForm';
  import ResendConsent from '../status/ResendConsent/ResendConsent';
import SendSms from '../status/SendSms/SendSms.js';
import { appContextConstants } from '../../constants/appContext.constants';
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
  });

 export default function IndividualProfile() {
  const location=useLocation();
  const navigate=useNavigate();
  const [searchParams] = useSearchParams();
  const coappIdFromUrl = searchParams.get('coapplicantId');
  const userIdFromUrl = searchParams.get('userId');
  const appIdFromUrl = searchParams.get('appId');
  const statusFromUrl = searchParams.get('status');
  const {
    selectedUserId: reduxSelectedUserId,
    coapplicantId: reduxCoapplicantId,
    repaymentsUserId: reduxRepaymentsUserId,
    repaymentsAppId: reduxRepaymentsAppId,
    status: reduxStatus,
    appId: reduxAppId,
    userId: reduxUserId,
  } = useSelector(state => state.appContext);
  const selectedUserId = reduxSelectedUserId;
  const [selectedUser, setSelectedUser] = useState(null);
  const [checked, setChecked] = useState(location?.state?.clickEvent==="coapp"?false:true);
  const firstCoappId =(location?.state?.coapplicantId)?(typeof location?.state?.coapplicantId == "string")?location?.state?.coapplicantId:location?.state?.coapplicantId[0]:coappIdFromUrl?coappIdFromUrl:reduxCoapplicantId?reduxCoapplicantId:""

  // track whether a coapplicant is available for rendering the switch/button
  const initialHasCoapplicant = Boolean(
    (location?.state?.coapplicantId && location?.state?.coapplicantId !== "undefined") ||
    (coappIdFromUrl && coappIdFromUrl !== "undefined") ||
    (reduxCoapplicantId && reduxCoapplicantId !== "undefined")
  );
  const [hasCoapplicant, setHasCoapplicant] = useState(initialHasCoapplicant);

  // keep hasCoapplicant in sync if the location state changes (e.g. after navigation)
  useEffect(() => {
    const current = Boolean(
      (location?.state?.coapplicantId && location?.state?.coapplicantId !== "undefined") ||
      (coappIdFromUrl && coappIdFromUrl !== "undefined") ||
      (reduxCoapplicantId && reduxCoapplicantId !== "undefined")
    );
    setHasCoapplicant(current);
  }, [location?.state, reduxCoapplicantId]);

  const  curruserId=selectedUser? selectedUser: checked?location?.state?.applicantId?location?.state?.applicantId:(userIdFromUrl || reduxRepaymentsUserId):firstCoappId
  const applicantId = location?.state?.applicantId || userIdFromUrl || reduxRepaymentsUserId;
  const isCoapplicantProfile = useMemo(
    () => Boolean(curruserId) && curruserId !== applicantId,
    [curruserId, applicantId]
  );
  const isCoapplicant = isCoapplicantProfile ? 1 : 0;
 // 
  const viaCibil=location?.state?.viaCibil
  const viaPreScreen=location?.state?.viaPreScreen
  const [integrationStatuses, setIntegrationStatuses] = useState({
    digilockerStatus: location?.state?.digilockerStatus,
    selfie: location?.state?.selfie,
    agreement: location?.state?.agreement,
    emandate: location?.state?.emandate,
    applicantFraudCheck: location?.state?.applicantFraudCheck,
    paymentStatus: location?.state?.paymentStatus,
  });
  const [sanctionEmiFirstDate, setSanctionEmiFirstDate] = useState('');
  //
  const  currapplicationId=location?.state?.applicationId?location?.state?.applicationId:(appIdFromUrl || reduxRepaymentsAppId)
  const decode = useCurrentUser();
  const user = null;
  const status = statusFromUrl || reduxStatus
  const [bankSelfieData,setBankSelfieData]=useState(null)
  const [profileDetails,setProfileDetails]=useState(null)
  const [rules,setRules] = useState(null)
  const [activityData,setActivityDetails]=useState(null)
  
  // Disbursement modal states
  const [selectedStatusOpen, setSelectedStatusOpen] = useState(false);
  const [displaySelected, setDisplaySelected] = useState(null);
  const [selectedName, setSelectedName] = useState(null);
  const [isLoadingDisbursement, setIsLoadingDisbursement] = useState(false);

   const activityState=useSelector((state)=>state?.ACTIVITY?.activityData)
    const profileUrl = useMemo(() => {
      if (curruserId === location?.state?.applicantId || curruserId === reduxRepaymentsUserId) {
        return `/summary/user?id=${curruserId}&applicationId=${currapplicationId}&status=${location?.state?.dir || "Disbursed"}`;
      } else if (selectedUser !== null && selectedUser === selectedUserId && selectedUser !== location?.state?.applicantId) {
        return `/summary/coapplicant?id=${curruserId}&applicationId=${currapplicationId}&status=${location?.state?.dir || "Disbursed"}`;
      } else if (checked) {
        return `/summary/user?id=${curruserId}&applicationId=${currapplicationId}&status=${location?.state?.dir || "Disbursed"}`;
      } else {
        if (curruserId !== location?.state?.applicantId) {
          return `/summary/coapplicant?id=${curruserId}&applicationId=${currapplicationId}&status=${location?.state?.dir || "Disbursed"}`;
        }
      }
    }, [selectedUser, selectedUserId, location?.state?.applicantId, checked]);
  // const profileUrl=checked?`/summary/user?id=${curruserId}&applicationId=${currapplicationId}&status=${location?.state?.dir?location?.state?.dir:"Disbursed"}`:`/summary/coapplicant?id=${curruserId}&applicationId=${currapplicationId}&status=${location?.state?.dir?location?.state?.dir:"Disbursed"}`;

  // const profileUrl=(selectedUser && selectedUser!==location?.state?.applicantId )? `/summary/coapplicant?id=${curruserId}&applicationId=${currapplicationId}&status=${location?.state?.dir?location?.state?.dir:"Disbursed"}`: checked?`/summary/user?id=${curruserId}&applicationId=${currapplicationId}&status=${location?.state?.dir?location?.state?.dir:"Disbursed"}`:`/summary/coapplicant?id=${curruserId}&applicationId=${currapplicationId}&status=${location?.state?.dir?location?.state?.dir:"Disbursed"}`;

  const bankSelfieUrl=`/integrations/details?applicationId=${currapplicationId
  }&userId=${curruserId}`;
 
   const urlForBankSelfie=`/integrations/application-profile?applicationId=${currapplicationId}`
   const [foirRefData,setFoirRefData]=useState(null)
    
  const getFoirRefUrl=`/admin/application/additional-info?applicationId=${currapplicationId}`
  const rulesUrl = `/go-rules/get-result?applicationId=${currapplicationId}&userId=${curruserId}`;

  const customerDashboardLoginUrl = `/login/admin`;
  const getActivityUrl=`/audit?applicationId=${currapplicationId}`
 
  const dispatch = useDispatch();

  useEffect(() => {
    if (userIdFromUrl || appIdFromUrl) {
      dispatch({ type: 'SET_REPAYMENTS_CONTEXT', payload: {
        repaymentsUserId: userIdFromUrl || undefined,
        repaymentsAppId: appIdFromUrl || undefined
      }});
      if (statusFromUrl) {
        dispatch({ type: 'SET_APP_CONTEXT', payload: { status: statusFromUrl }});
      }
    }
  }, [userIdFromUrl, appIdFromUrl, statusFromUrl]);

  // Handle Create Disbursement button click - calls disbursement/create API
  const handlePayouts = (applicationId) => {
    setIsLoadingDisbursement(true);
    const urlGetSelectedApp = `/disbursement/create`;
    const data = {
      applicationId: applicationId
    };
    axiosInstance.post(urlGetSelectedApp, data, {
      headers: {
      }
    }).then((res) => {
      setDisplaySelected(res.data.data);
      setSelectedName(profileDetails?.firstName + " " + profileDetails?.lastName);
      setSelectedStatusOpen(true);
      setIsLoadingDisbursement(false);
    }).catch((error) => {
      alert(error?.response?.data?.message);
      setIsLoadingDisbursement(false);
    });
  };

  useEffect(() => {
    if(viaCibil || (viaPreScreen && decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361')){
        toggle('4')
    }else if(viaPreScreen){
      toggle('3')
    }

  const controller = new AbortController();
  if(activityState?.res?.data?.data){
    setActivityDetails(activityState?.res?.data?.data)
  }

  const fetchData = async () => {
    setError(null);
    try {
      const isInSubmission = status === "In Submission" || status === "In Review";
      
      try {
        const summaryResponse = await axiosInstance.get(profileUrl, {
          signal: controller.signal,
        });
        setProfileDetails({
          ...(summaryResponse?.data?.data || {}),
          isCoapplicant,
        });
      } catch (err) {
        if (err.name !== 'CanceledError') {
          console.error("Failed to fetch profile data:", err);
        }
      }
      
      if (!isInSubmission) {
        try {
          const rulesResponse = await axiosInstance.get(rulesUrl, {
            signal: controller.signal,
          });
          setRules(rulesResponse?.data?.data[0]);
        } catch (err) {
          if (err.name !== 'CanceledError') {
            console.error("Failed to fetch rules:", err);
          }
        }

      }

      if (status !== "In Submission") {
        try {
          const foirResponse = await axiosInstance.get(getFoirRefUrl, {
            signal: controller.signal,
          });
          setFoirRefData(foirResponse?.data?.data);
        } catch (err) {
          if (err.name !== 'CanceledError') {
            console.error("Failed to fetch FOIR reference data:", err);
          }
        }
      }      
    } catch (err) {
      if (err.name !== 'CanceledError') {
        console.error("Failed to fetch data:", err);
        setError("Could not load data. Please try again.");
      }
    } finally {
    }
  };

  fetchData();

  return () => {
    controller.abort();
  };
  
}, [user, currapplicationId, curruserId, profileUrl, bankSelfieUrl,getActivityUrl, isCoapplicant]);

  useEffect(() => {
    if (!['In Sanction', 'Ready to Disburse'].includes(status) || !currapplicationId) return;
    setIntegrationStatuses({ digilockerStatus: null, selfie: null, agreement: null, emandate: null, applicantFraudCheck: null, paymentStatus: null });
    axiosInstance.get('/integrations/applications', {
      params: { status, applicationId: currapplicationId, perPage: 10, pageNo: 1 },
    }).then((res) => {
      const details = res?.data?.data?.details || [];
      const item = details.find(
        (d) => d.applicationId === currapplicationId && d.userId === curruserId
      );
      if (item) {
        setIntegrationStatuses({
          digilockerStatus: item?.digilockerStatus || null,
          selfie: item?.selfie || null,
          agreement: item?.agreement || null,
          emandate: item?.emandate || null,
          applicantFraudCheck: item?.applicantFraudCheck || null,
          paymentStatus: item?.paymentStatus || null,
        });
        if (item?.emiFirstDate) setSanctionEmiFirstDate(item.emiFirstDate);
      } else {
        // curruserId is a co-applicant — find their data inside the parent item's coapplicants array
        const parentItem = details.find(
          (d) => d.applicationId === currapplicationId &&
                 d.coapplicants?.some((c) => c.coapplicantId === curruserId)
        );
        const coapp = parentItem?.coapplicants?.find((c) => c.coapplicantId === curruserId);
        setIntegrationStatuses({
          digilockerStatus: coapp?.coapplicantDigilockerStatus || null,
          selfie: coapp?.coapplicantSelfie || null,
          agreement: coapp?.coapplicantAgreement || null,
          emandate: coapp?.coapplicantEmandate || null,
          applicantFraudCheck: coapp?.coapplicantFraudCheck || null,
          paymentStatus: parentItem?.paymentStatus || null,
        });
      }
    }).catch(() => {});
  }, [user, currapplicationId, curruserId, status]);


const statusIndex = {
    submission : 'In Submission',
    Review : 'In Review',
    Process : 'In Process',
    Pending :'Pending Disbursement',
    onHold: 'On Hold',
    dropped: 'Dropped',
    rejected:'Rejected',
    sanction:'In Sanction',
    disbursement:'Ready to Disburse',
    disbursed:'Disbursed'

  }
 
  const formattedStatus =  Object.keys(statusIndex).find(key => statusIndex[key] === status) || status
  const isInSubmission = status === "In Submission";
  const defaultActiveTab = decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? '0' : '1';
  const [activeTab, setActiveTab] = useState(defaultActiveTab);
   
  const handleChange = (event) => {
    setChecked(event.target.checked);
    setSelectedUser(null);
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { selectedUserId: null } });
  };

  const parseNumber = (value) => {
    if (value === null || value === undefined || value === '') return null;
    return typeof value === 'number' ? value : Number(value);
  };

  const getScoreColor = (value, threshold = 70, invert = false) => {
    const score = parseNumber(value);
    if (score === null || Number.isNaN(score)) return '#667085';
    if (invert) return score > threshold ? '#D22129' : '#12B76A';
    return score < threshold ? '#D22129' : '#12B76A';
  };

  const getCircleColor = (value) => {
    if (value === null || value === undefined) return '#667085';
    return String(value) === '1' ? '#12B76A' : '#D22129';
  };


  const handleCoapplicant = (id) => {
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { selectedUserId: id } });
    setSelectedUser(id)
  };

  const getRemovableCoapplicantId = () => {
    if (selectedUser && selectedUser !== applicantId) return selectedUser;
    if (!checked && curruserId && curruserId !== applicantId) return curruserId;
    if (Array.isArray(location?.state?.coapplicantId)) return location?.state?.coapplicantId[0] || '';
    if (location?.state?.coapplicantId) return location?.state?.coapplicantId;
    return reduxCoapplicantId && reduxCoapplicantId !== "undefined" ? reduxCoapplicantId : '';
  };

  const handleRemoveCoapplicant = () => {
    const removableCoapplicantId = getRemovableCoapplicantId();
    if (!removableCoapplicantId) {
      setRemoveStatus({ open: true, message: 'Co-applicant id not found', severity: 'error' });
      return;
    }
    // open confirmation dialog instead of native confirm
    setIsRemoveDialogOpen(true);
  };

  const confirmRemoveCoapplicant = async () => {
    setIsRemoveDialogOpen(false);
    const removableCoapplicantId = getRemovableCoapplicantId();
    if (!removableCoapplicantId) {
      setRemoveStatus({ open: true, message: 'Co-applicant id not found', severity: 'error' });
      return;
    }

    try {
      const body = {
        applicationId: currapplicationId || profileDetails?.applicationId,
        userId: removableCoapplicantId,
      };

      const res = await axiosInstance.post('/admin/application/remove-coapplicant', body, {
        headers: {
        },
      });

      if (res?.data?.data === true) {
        dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { selectedUserId: null, coapplicantId: null, coappId: null } });
        setHasCoapplicant(false);
        setChecked(true);
        setSelectedUser(null);
        setRemoveStatus({ open: true, message: 'Co-applicant removed successfully', severity: 'success' });
      } else {
        setRemoveStatus({ open: true, message: res?.data?.message || 'Unable to remove co-applicant', severity: 'error' });
      }
    } catch (err) {
      setRemoveStatus({ open: true, message: err?.response?.data?.message || 'Failed to remove co-applicant', severity: 'error' });
    }
  };
   const [visitedTabs, setVisitedTabs] = useState({ [defaultActiveTab]: true });
 const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
       if (!visitedTabs[tab]) {
        setVisitedTabs(prevVisited => ({
          ...prevVisited,
          [tab]: true,
        }));
      }
    }
  };


  const [isDialogOpen, setIsDialogOpen] = useState(false);
  // confirmation modal for removing co-applicant
  const [isRemoveDialogOpen, setIsRemoveDialogOpen] = useState(false);
  // status message shown after attempting removal (success or error)
  const [removeStatus, setRemoveStatus] = useState({ open: false, message: '', severity: 'success' });
    
    const handleOpenDialog = () =>{
      setIsDialogOpen(true);
      handleNavigateActivity();
    }
    const handleCloseDialog = () => setIsDialogOpen(false);

  const handleNavigateActivity=()=>{
    dispatch({ type: appContextConstants.SET_ACTIVITY_CONTEXT, payload: {
      activityUserId: curruserId,
      activityAppId: currapplicationId,
      activityAppStatus: status,
    }});
    const urlForApplicationDetails = `/admin/application/application-profile?applicationId=${currapplicationId}`;

    if (currapplicationId) {
      axiosInstance
        .get(urlForApplicationDetails, {
          headers: {
          },
        })
        .then((res) => {
          dispatch({ type: appContextConstants.SET_ACTIVITY_CONTEXT, payload: {
            activityAppLegacyLoanId: res?.data?.data?.profile?.disbursementData?.legacyLoanId,
            activityAppLoanId: res?.data?.data?.profile?.disbursementData?.loanId,
            activityAppStatus: res?.data?.data?.status,
          }});
        })
        .catch((err) => {
          console.error(err, "Error");
          dispatch({ type: appContextConstants.SET_ACTIVITY_CONTEXT, payload: { activityAppStatus: null, activityAppLegacyLoanId: null } });
        });
    }
    // navigate('/status/profile/activity',{
    //   state:{
    //     activityDetails:activityData
    //   }
    // })
  }

  const ref=useRef(null)
  const modalRef = useRef();
  function formatNumberWithCommas(number) {
    return number?.toLocaleString('en-IN'); 
  }

  const dateOfBirth = new Date(profileDetails?.dateOfBirth);
  const today = new Date();
  
  let age = today.getFullYear() - dateOfBirth.getFullYear();
  
  if (today.getMonth() < dateOfBirth.getMonth() || (today.getMonth() === dateOfBirth.getMonth() && today.getDate() < dateOfBirth.getDate())) {
    age--; 
  }

  const handleApplicationProfile=(currApplicationId,currUserId)=>{
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { appId: currApplicationId, userId: currUserId } });
    // const urlForApplicationDetails=`/admin/application/application-profile?applicationId=${currapplicationId}`
    // const urlForBankSelfie=`/integrations/application-profile?applicationId=${currapplicationId}`
    // const getEmiUrl=`/emis?applicationId=${currapplicationId}`
    // const getActivityUrl=`/audit?applicationId=${currapplicationId}`
    
    // dispatch(userActions.fetchUrlforApplicationdetails(urlForApplicationDetails,user),[])
    // dispatch(userActions.fetchUrlforbankselfie(urlForBankSelfie,user),[])
    // dispatch(userActions.fetchEmiUrl(getEmiUrl,user),[])
    // dispatch(userActions.getActivity(getActivityUrl,user))
    navigate(`/status/${formattedStatus}/appProfile`)
    
  }



  const [editModal,setEditModal]=useState(false)
  const [addRef2,setAddRef2]=useState(false)
  const [addRef3,setAddRef3]=useState(false)
  const [refName,setRefName]=useState(null)
  const [ref2Name,setRef2Name]=useState(null)
  const [ref3Name,setRef3Name]=useState(null)
  const [relationship,setRelationship]=useState("")
  const [relationship2,setRelationship2]=useState("")
  const [relationship3,setRelationship3]=useState("")
  const [refMobile,setRefMobile]=useState(null)
  const [ref2Mobile,setRef2Mobile]=useState(null)
  const [ref3Mobile,setRef3Mobile]=useState(null)
  const [whatsAppMobile,setWhatsAppMobile]=useState(null)
  const [whatsAppText,setWhatsAppText]=useState(null)
  const postFoirRefUrl=`/admin/application/additional-info`
  const summaryUpdateUrl=`/integrations/update-whatsapp-number`;
  const saveReferenceDetails=()=>{  
  

    const data={
      userId: reduxUserId,
      applicationId: reduxAppId,
      contact1: refMobile?refMobile?.trim():foirRefData?.contact1?foirRefData?.contact1:'',
      contact1Relation:relationship?relationship?.trim():foirRefData?.contact1Relation?foirRefData?.contact1Relation:'',
      contact1Name: refName?refName?.trim():foirRefData?.contact1Name?foirRefData?.contact1Name:'',
      contact1NameAsPerMobileLookup: verifiedName1?verifiedName1?.trim():foirRefData?.contact1NameAsPerMobileLookup?foirRefData?.contact1NameAsPerMobileLookup:'',
      contact2: ref2Mobile?ref2Mobile?.trim():foirRefData?.contact2?foirRefData?.contact2:'',
      contact2Relation: relationship2?relationship2?.trim():foirRefData?.contact2Relation?foirRefData?.contact2Relation:'',
      contact2Name: ref2Name?ref2Name?.trim():foirRefData?.contact2Name?foirRefData?.contact2Name:'',
      contact2NameAsPerMobileLookup: verifiedName2?verifiedName2?.trim():foirRefData?.contact2NameAsPerMobileLookup?foirRefData?.contact2NameAsPerMobileLookup:'',
      contact3: ref3Mobile?ref3Mobile?.trim():foirRefData?.contact3?foirRefData?.contact3:'',
      contact3Relation: relationship3?relationship3?.trim():foirRefData?.contact3Relation?foirRefData?.contact3Relation:'',
      contact3Name: ref3Name?ref3Name?.trim():foirRefData?.contact3Name?foirRefData?.contact3Name:'',
      contact3NameAsPerMobileLookup: verifiedName3?verifiedName3?.trim():foirRefData?.contact3NameAsPerMobileLookup?foirRefData?.contact3NameAsPerMobileLookup:'',

    }
    dispatch(userActions.postFoirDetails(postFoirRefUrl,data,user))
    if(whatsAppMobile){
    const body = {
            applicationId: reduxAppId,
            userId: reduxUserId,
            whatsappNumber: whatsAppMobile,
          }

          axiosInstance.post(summaryUpdateUrl, body, {
            headers: {
            },
          })
          .then((res)=>{
            if(res?.data?.message === "Successful"){
              alert("Updated Successfully")
              window.location.reload();
            }
          })
          .catch((err) => err)
        }
    setEditModal(false)

  }

  const [documentToggle,setDocumentToggle]=React.useState(false)
const handleDocToggle = () => {
    setDocumentToggle(!documentToggle);
  };
  const [selfiePath,setSelfiePath] = useState(null)

   useEffect(() => {
     const fetchDocs = async () => {
       try {
         const res = await axiosInstance.get(
           `/integrations/selfie-url?applicationId=${currapplicationId}&userId=${curruserId}`,
         );
         const { agreementUrl, sanctionLetter, selfiePath: selfiePathFromApi } = res?.data?.data;
         setBankSelfieData({ agreementUrl, sanctionLetter });
         if (selfiePathFromApi) {
           const urlRes = await axiosInstance.get(`/file/url-content?path=${selfiePathFromApi}`, {
           });
           setSelfiePath(urlRes?.data?.data);
         } else {
           setSelfiePath(null);
         }
       } catch (err) {
         console.error("Failed to fetch docs:", err);
       }
     };
     if (currapplicationId) {
       fetchDocs();
     }
   }, [currapplicationId, curruserId]);
   
  const [modal, setModal] = useState(false);
  const [agreementUrl,setAgreementUrl] = useState(null)
  const toggle1 = () => {
    if (!modal) {
      const url = `/file/url-content?path=${bankSelfieData?.agreementUrl}`
      axiosInstance
          .get(url, {
            headers: {
            },
          })
          .then((res)=>{
            setAgreementUrl(res?.data?.data)
            })
    }
    setModal(!modal)
  };

  const [sanctionModal, setModalSanction] = useState(false);
  const [sanctionUrl,setSanctionUrl] = useState(null)

  const toggleSanction = () => {
    if (!sanctionModal) {
      const url = `/file/url-content?path=${bankSelfieData?.sanctionLetter}`
      axiosInstance
          .get(url, {
            headers: {
            },
          })
          .then((res)=>{
            setSanctionUrl(res?.data?.data)
            })
    }
    setModalSanction(!sanctionModal)
  };



  const openCustomerDashboard = (mobile) => {
    dispatch(
      userActions.openCustomerDashboard(customerDashboardLoginUrl, user, mobile)
    );
  };
  const [error, setError] = useState("");
  const [verifiedName1,setVerifiedName1] = useState("")
  const [verifiedName2,setVerifiedName2] = useState("")
  const [verifiedName3,setVerifiedName3] = useState("")
  const [loading1,setLoading1] = useState(false)
  const [loading2,setLoading2] = useState(false)
  const [loading3,setLoading3] = useState(false)
  const [loading4,setLoading4] = useState(false)
  const validateNumber = (number) => /^\d{10}$/.test(number);

  const handleVerify = (mobile, index) => {
  if (index === "1") {
    setLoading1(true);
  } else if (index === "2") {
    setLoading2(true);
  } else {
    setLoading3(true);
  }

  const url = `admin/application/verify-reference-number`;
  
  const body = {
    userId: reduxUserId,
    applicationId: reduxAppId,
    doneBy: decode?.display_name
  };

  switch (index) {
    case "1":
      body.contact1 = refMobile?.trim() || foirRefData?.contact1 || '';
      body.contact1Relation = relationship?.trim() || foirRefData?.contact1Relation || '';
      body.contact1Name = refName?.trim() || foirRefData?.contact1Name || '';
      body.contact1NameAsPerMobileLookup = verifiedName1?.trim() || foirRefData?.contact1NameAsPerMobileLookup || '';
      break;
    case "2":
      body.contact2 = ref2Mobile?.trim() || foirRefData?.contact2 || '';
      body.contact2Relation = relationship2?.trim() || foirRefData?.contact2Relation || '';
      body.contact2Name = ref2Name?.trim() || foirRefData?.contact2Name || '';
      body.contact2NameAsPerMobileLookup = verifiedName2?.trim() || foirRefData?.contact2NameAsPerMobileLookup || '';
      break;
    case "3":
      body.contact3 = ref3Mobile?.trim() || foirRefData?.contact3 || '';
      body.contact3Relation = relationship3?.trim() || foirRefData?.contact3Relation || '';
      body.contact3Name = ref3Name?.trim() || foirRefData?.contact3Name || '';
      body.contact3NameAsPerMobileLookup = verifiedName3?.trim() || foirRefData?.contact3NameAsPerMobileLookup || '';
      break;
  }
  
  axiosInstance.post(url, body)
    .then((res) => {
      const verifiedName = res?.data?.data?.[`contact${index}NameAsPerMobileLookup`];
      
      if (verifiedName !== undefined) {
          if (index === "1") setVerifiedName1(verifiedName);
          else if (index === "2") setVerifiedName2(verifiedName);
          else setVerifiedName3(verifiedName);
      }
    })
    .catch((err) => {
      alert("Error in verifying name");
    })
    .finally(() => {
        setLoading1(false);
        setLoading2(false);
        setLoading3(false);
    });
};

  const [typeOfBusiness,setTypeOfBusiness] = useState("")
  const [employerName,setEmployerName] = useState("")
  const [salary, setSalary] = useState("")
  const [incomePerMonth, setIncomePerMonth] = useState("")
  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSave = () => {
    const updateUrl = `/users/employment-details/update`
    const employmentType = value === 1 ? "salaried" : "self-employed";
    const body ={
      employmentType,
      userId:profileDetails.userId,
      applicationId:profileDetails.applicationId,
      ...(employmentType === "salaried"
        ? {
            employerName: employerName,
            salary: salary,
          }
        : {
            typeOfBusiness:typeOfBusiness,
            incomePerMonth: incomePerMonth,
          }),
    }
    axiosInstance.post(updateUrl,body)
    .then((res)=>{
      if(res?.data?.message === "Successful"){
        alert("Updated Successfully")
        setOpen(false);
        window.location.reload()
      }
    }).catch((err)=>{
    })
  };
  const handleVerifyWhatsapp = () => {
    setLoading4(true)
    const updateUrl = `/users/basic-info/verify-whatsapp`
    const body ={
      userId:profileDetails.userId,
      mobile:whatsAppMobile?whatsAppMobile?.trim():profileDetails?.whatsappNumber?profileDetails?.whatsappNumber:''
    }
    axiosInstance.post(updateUrl,body,{
      headers: {
      },
    })
    .then((res)=>{
      if(res?.data?.message === "Successful"){
        setWhatsAppText(res?.data?.data)
        setLoading4(false)
      }
    }).catch((err)=>{
    })
  };

  const handleOpen = () => {
    const employmentType = profileDetails?.employmentType?.toLowerCase();
    setSalary(profileDetails?.salary || '');
    setIncomePerMonth(profileDetails?.incomePerMonth || '');
    if (employmentType === 'salaried') {
      setValue(1);
      setEmployerName(profileDetails?.employerName || '');
      setTypeOfBusiness('');
    } else {
      setValue(0);
      setTypeOfBusiness(profileDetails?.typeOfBusiness || '');
      setEmployerName('');
    }
    setOpen(true);
  };
  

  const handleClose = () => {
    setOpen(false);
  };
   
  return (
  <>
   <Card className="card" style={{width:"100%"}} >

          <Dialog
            open={editModal} 
            maxWidth="md" 
            fullWidth
          >
      <DialogTitle sx={{ fontSize: '1.2rem',paddingTop:'1.5rem' }}>Edit Details or Add Reference Contacts</DialogTitle>
      <Divider sx={{ my: 0.1 }} />
      <DialogContent>
        <Grid container spacing={3} sx={{ mb: 2 }}>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" fontWeight="bold">Email Id</Typography>
            <TextField 
              fullWidth
              defaultValue={profileDetails?.email}
              disabled
              variant="outlined"
              size="small"
              sx={{ mt: 1 }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" fontWeight="bold">Phone Number</Typography>
            <TextField 
              fullWidth
              defaultValue={profileDetails?.mobile}
              disabled
              variant="outlined"
              size="small"
              sx={{ mt: 1 }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" fontWeight="bold">Date of Birth</Typography>
            <TextField 
              fullWidth
              defaultValue={profileDetails?.dateOfBirth}
              disabled
              variant="outlined"
              size="small"
              sx={{ mt: 1 }}
            />
          </Grid>
        </Grid>

        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" fontWeight="bold">Current Address</Typography>
            <TextField 
              fullWidth
              multiline
              rows={3}
              defaultValue={profileDetails?.currentAddress}
              disabled
              variant="outlined"
              size="small"
              sx={{ mt: 1 }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" fontWeight="bold">Permanent Address</Typography>
            <TextField 
              fullWidth
              multiline
              rows={3}
              defaultValue={profileDetails?.permanentAddress}
              disabled
              variant="outlined"
              size="small"
              sx={{ mt: 1 }}
            />
          </Grid>
        </Grid>

        <Divider sx={{ my: 2, borderStyle: 'dashed' }} />
        {status !== ("In Submission" || "In Process" || "In Review")?<>
         <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
          <Typography variant="subtitle1" fontWeight="bold">Appl. WhatsApp Contact Name</Typography>
            <TextField 
              fullWidth
              defaultValue={profileDetails?.firstName ? profileDetails?.firstName:"" + " " +profileDetails?.lastName?profileDetails?.lastName:''}
              onChange={(e) => setRef3Name(e.target.value)}
              variant="outlined"
              size="small"
              sx={{ mt: 1 }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
          <Typography variant="subtitle1" fontWeight="bold">Appl.WhatsApp Number</Typography>
          <TextField 
              fullWidth
              type="text"
              defaultValue={profileDetails?.whatsappNumber}
              onChange={(e) => setWhatsAppMobile(e.target.value)}
              variant="outlined"
              size="small"
              sx={{ mt: 1}}
            />
          </Grid>
          <Grid item xs={12} md={4}>
          <Typography variant="subtitle1" fontWeight="bold">Verify Number</Typography>
          <Button
                disabled={!validateNumber(whatsAppMobile)}
                variant="contained"
                size="small"
                onClick={() => handleVerifyWhatsapp(whatsAppMobile)}
                sx={{ 
                  bgcolor: validateNumber(whatsAppMobile) ? 'primary.main' : 'grey.400',
                  '&:hover': {
                    bgcolor: validateNumber(whatsAppMobile) ? 'primary.dark' : 'grey.400'
                  },height:'40px',mt:1,width:'45%'
                }}
              >
                {loading4 ? "Verifying..." : "Verify"}  
              </Button>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 2 }}>{whatsAppText && (
              <Typography variant="body2" sx={{ mt: 0.5, mb: whatsAppText ? 1 : 0 }}>
                <Box component="span" sx={{ color: whatsAppText === "valid"?'green':'red' }}>{whatsAppText}</Box>
              </Typography>
            )}</Typography>
          </Grid>
        </Grid>
        </>:""}
       
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" fontWeight="bold">1st Reference Contact Name</Typography>
             <Typography variant="body2" sx={{ mt: 0.5, mb: verifiedName1 ? 1 : 0 }}>
                Verified Name: <Box component="span" sx={{ color: 'green' }}>{foirRefData?.contact1NameAsPerMobileLookup ? foirRefData?.contact1NameAsPerMobileLookup:""}</Box>
              </Typography>
            <TextField 
              fullWidth
              defaultValue={foirRefData?.contact1Name}
              onChange={(e) => setRefName(e.target.value)}
              variant="outlined"
              size="small"
              sx={{ mt: 1 }}
            />
            {verifiedName1 && (
              <Typography variant="body2" sx={{ mt: 0.5, mb: verifiedName1 ? 1 : 0 }}>
                Verified Name: <Box component="span" sx={{ color: 'green' }}>{verifiedName1}</Box>
              </Typography>
            )}
            
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
              <Typography variant="subtitle1" fontWeight="bold">Contact 1</Typography>
              <Button
                disabled={!!verifiedName1 || !!foirRefData?.contact1NameAsPerMobileLookup}
                variant="contained"
                size="small"
                onClick={() => handleVerify(refMobile, "1")}
                sx={{ 
                  ml: 1
                }}
              >
                {loading1 ? "Verifying..." : "Verify"}
              </Button>
            </Box>
            
            {error && <Typography color="error" variant="caption">{error}</Typography>}
            
            <TextField 
              fullWidth
              type="text"
              defaultValue={foirRefData?.contact1}
              onChange={(e) => setRefMobile(e.target.value)}
              variant="outlined"
              size="small"
              sx={{ mt: 1 }}
            />
            
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 2 }}>Relationship</Typography>
            <FormControl fullWidth size="small" sx={{ mt: 1 }}>
              <Select
                value={relationship}
                onChange={(e) => setRelationship(e.target.value)}
                displayEmpty
                defaultValue={foirRefData?.contact1Relation || ""}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="Sibling/Relative">Sibling / Relative</MenuItem>
                <MenuItem value="Parent/Guardian">Parent / Guardian</MenuItem>
                <MenuItem value="Friend/Colleague">Friend / Colleague</MenuItem>
                <MenuItem value="Spouse">Spouse</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" fontWeight="bold">2nd Reference Contact Name</Typography>
             <Typography variant="body2" sx={{ mt: 0.5, mb: verifiedName1 ? 1 : 0 }}>
                Verified Name: <Box component="span" sx={{ color: 'green' }}>{foirRefData?.contact2NameAsPerMobileLookup ? foirRefData?.contact2NameAsPerMobileLookup:""}</Box>
              </Typography>

            <TextField 
              fullWidth
              defaultValue={foirRefData?.contact2Name}
              onChange={(e) => setRef2Name(e.target.value)}
              variant="outlined"
              size="small"
              sx={{ mt: 1 }}
            />
            {verifiedName2 && (
              <Typography variant="body2" sx={{ mt: 0.5, mb: verifiedName2 ? 1 : 0 }}>
                Verified Name: <Box component="span" sx={{ color: 'green' }}>{verifiedName2}</Box>
              </Typography>
            )}
            
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
              <Typography variant="subtitle1" fontWeight="bold">Contact 2</Typography>
              <Button
                disabled={!!verifiedName2 || !!foirRefData?.contact2NameAsPerMobileLookup}
                variant="contained"
                size="small"
                onClick={() => handleVerify(ref2Mobile, "2")}
                sx={{ 
                  ml: 1
                }}
              >
                {loading2 ? "Verifying..." : "Verify"}
              </Button>
            </Box>
            
            <TextField 
              fullWidth
              type="text"
              defaultValue={foirRefData?.contact2}
              onChange={(e) => setRef2Mobile(e.target.value)}
              variant="outlined"
              size="small"
              sx={{ mt: 1 }}
            />
            
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 2 }}>Relationship</Typography>
            <FormControl fullWidth size="small" sx={{ mt: 1 }}>
              <Select
                value={relationship2}
                onChange={(e) => setRelationship2(e.target.value)}
                displayEmpty
                defaultValue={foirRefData?.contact2Relation || ""}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="Sibling/Relative">Sibling / Relative</MenuItem>
                <MenuItem value="Parent/Guardian">Parent / Guardian</MenuItem>
                <MenuItem value="Friend/Colleague">Friend / Colleague</MenuItem>
                <MenuItem value="Spouse">Spouse</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4}>
          <Typography variant="subtitle1" fontWeight="bold">3rd Reference Contact Name</Typography>
           <Typography variant="body2" sx={{ mt: 0.5, mb: verifiedName1 ? 1 : 0 }}>
                Verified Name: <Box component="span" sx={{ color: 'green' }}>{foirRefData?.contact3NameAsPerMobileLookup ? foirRefData?.contact3NameAsPerMobileLookup:""}</Box>
              </Typography>
            <TextField 
              fullWidth
              defaultValue={foirRefData?.contact3Name}
              onChange={(e) => setRef3Name(e.target.value)}
              variant="outlined"
              size="small"
              sx={{ mt: 1 }}
            />
            {verifiedName3 && (
              <Typography variant="body2" sx={{ mt: 0.5, mb: verifiedName3 ? 1 : 0 }}>
                Verified Name: <Box component="span" sx={{ color: 'green' }}>{verifiedName3}</Box>
              </Typography>
            )}
            
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
              <Typography variant="subtitle1" fontWeight="bold">Contact 3</Typography>
              <Button
                disabled={!!verifiedName3 || !!foirRefData?.contact3NameAsPerMobileLookup}
                variant="contained"
                size="small"
                onClick={() => handleVerify(ref3Mobile, "3")}
                sx={{ 
                  ml: 1
                }}
              >
                {loading3 ? "Verifying..." : "Verify"}
              </Button>
            </Box>
            
            <TextField 
              fullWidth
              type="number"
              defaultValue={foirRefData?.contact3}
              onChange={(e) => setRef3Mobile(e.target.value)}
              variant="outlined"
              size="small"
              sx={{ mt: 1 }}
            />
            
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 2 }}>Relationship</Typography>
            <FormControl fullWidth size="small" sx={{ mt: 1 }}>
              <Select
                value={relationship3}
                onChange={(e) => setRelationship3(e.target.value)}
                displayEmpty
                defaultValue={foirRefData?.contact3Relation || ""}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="Sibling/Relative">Sibling / Relative</MenuItem>
                <MenuItem value="Parent/Guardian">Parent / Guardian</MenuItem>
                <MenuItem value="Friend/Colleague">Friend / Colleague</MenuItem>
                <MenuItem value="Spouse">Spouse</MenuItem>
              </Select>
            </FormControl>
           
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setEditModal(false)} sx={{marginRight:'3em'}} variant="contained" color="secondary">
          Close
        </Button>
        <Button 
          variant="contained" 
          onClick={() => saveReferenceDetails()}
          sx={{ bgcolor: '#d32028', '&:hover': { bgcolor: '#b71c1c' } }} color="secondary"
        >
          Save
        </Button>
      </DialogActions>
          </Dialog>
          <Modal isOpen={open} onClose={handleClose}>
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, 50%)',
                width: 400,
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 24,
                p: 4,
              }}
            >
              <Typography variant="h6" component="h2" sx={{ mb: 2, textAlign: 'center' }}>
                Employment Details
              </Typography>
              <Tabs value={value} onChange={handleTabChange} aria-label="Tab Modal">
                <Tab label="Self-Employed" />
                <Tab label="Salaried" />
              </Tabs>

              <Box sx={{ mt: 2 }}>
              {value === 0 ? (
                <>
                  <TextField
                    fullWidth
                    label="Type of Business"
                    placeholder="Type of Business"
                    variant="outlined"
                    value={typeOfBusiness}
                    onChange={(e) => setTypeOfBusiness(e.target.value)}
                  />
                  <TextField
                    fullWidth
                    label="Income Per Month"
                    placeholder="Income Per Month"
                    variant="outlined"
                    value={incomePerMonth}
                    onChange={(e) => setIncomePerMonth(e.target.value)}
                    sx={{ mt: 2 }}
                  />
                </>
              ) : (
                <>
                  <TextField
                    fullWidth
                    label="Employer Name"
                    placeholder="Employer Name"
                    variant="outlined"
                    value={employerName}
                    onChange={(e) => setEmployerName(e.target.value)}
                  />
                  <TextField
                    fullWidth
                    label="Salary"
                    placeholder="Salary"
                    variant="outlined"
                    value={salary}
                    onChange={(e) => setSalary(e.target.value)}
                    sx={{ mt: 2 }}
                  />
                </>
              )}
            </Box>

              <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                <Button onClick={handleClose} variant="contained" color="secondary">
                  Close
                </Button>
                <Button onClick={handleSave} variant="contained" color="primary">
                  Save
                </Button>
              </Box>
            </Box>
          </Modal>
          <div className="profileHighlight">
            <div style={{display:'flex', margin:'1.5em',alignItems:'center'}}>
              <img style={{width:'7vw',height:'11vw',marginRight:'1em'}} src={selfiePath}/>
              <div style={{lineHeight:1, flex:1}}>
                <p style={{fontSize:'20px',fontWeight:'600', alignItems: 'center'}}>
                  {profileDetails?.firstName?.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}<span> {profileDetails?.lastName?.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</span>
                  {/* Gender */}
                  {profileDetails?.gender && 
                    <>
                      {profileDetails?.gender=== "Male" ? <img src={MaleImg} alt="" style={{width: '30px', height: '28px', marginLeft:'8px'}} title="Male"/>: <img src={FemaleImg} alt="" style={{width: '32px', height: '28px', marginLeft:'8px'}} title="Female"/>
                      }
                    </>
                  }
                </p>
                <p style={{fontSize:'16px',color:'#667085',fontWeight:'bold'}}>Application Id : <span style={{cursor:'pointer',color:'#D32028',textDecoration:'underline'}} onClick={()=>handleApplicationProfile(currapplicationId,curruserId)}>{currapplicationId}</span>
                
                <span
                    onClick={() => {
                      openCustomerDashboard(profileDetails?.mobile);
                    }}
                    className="customerDashboardButton"
                  >
                    [ Preview Customer Dashboard ] 
                  </span>
                </p>
               <div style={{display:'flex', alignItems:'center',  marginBottom:'12px'}} >

               {(location?.state?.coapplicants?.length > 1 && hasCoapplicant)? 
               <span style={{ display: 'flex', alignItems: 'center', gap: '1em', flexWrap:'wrap'}}>
                <span className={`${'coappName'} ${( selectedUserId===location?.state?.applicantId)  && "selectedName"}`} onClick={() => handleCoapplicant( location?.state?.applicantId)}>{`${location?.state?.name}`}</span>
               
                {
                  location?.state?.coapplicants?.map((coapp, index) => {
                    return (
                      <span className={`${'coappName'} ${(selectedUserId===coapp?.coapplicantId) && "selectedName"}`}  key={index} onClick={() => handleCoapplicant(coapp?.coapplicantId)}>{`${coapp?.coapplicantName} - C${index+1}`}</span>
                     )
                  })
                }   
               </span>
               : hasCoapplicant ?
                
               <> <span style={{fontSize:'16px',fontWeight:'bold',fontFamily:'Outfit',color:checked?'#D32028':'#B0B0B0', }}>Applicant</span>
               <div style={{transform:'rotate(180deg)',width:'4em', textAlign:'center'}}>
                 <Switch
                  size='small'
                  checked={checked}
                  onChange={(e)=>handleChange(e)}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
              </div>
                <span style={{fontSize:'16px',fontWeight:'bold',fontFamily:'Outfit',color:!checked?'#D32028':'#B0B0B0'}}>Co-applicant</span>
                {(decode?.role === "admin" || decode?.role === "crm" && decode?.clientId === "d428c3d0-b5c7-4e9c-857b-e76c1cb8248c")?(
                  <>
                  {!checked && (
                  <Tooltip title="Remove Co-applicant">
                    <IconButton
                      size="small"
                      onClick={handleRemoveCoapplicant}
                      sx={{ ml: 0.5 }}
                    >
                      <DeleteOutlineIcon sx={{ color: '#D32028', fontSize: '18px' }} />
                    </IconButton>
                  </Tooltip>
                )}</>
                ):(null)}
                
                </>
                :
                <></>
                }
              

              </div>
                <p ><i style={{fontSize:'14px',color:'#667085',fontWeight:'bold'}}>{profileDetails?.employmentType} : </i><i style={{color:'#D32028'}}> {profileDetails?.employerName || profileDetails?.typeOfBusiness}</i> <img src={pencil} style={{height:'15px',marginLeft:'10px',marginTop:'-5px',cursor:'pointer'}} onClick={handleOpen}/></p>
                <div style={{display:'flex', alignItems:'center', color:'#667085', fontWeight:'bold', width:'100%', gap:'3em', flexWrap:'nowrap'}}>
                  <span style={{whiteSpace:'nowrap'}}>Amount : <span style={{fontWeight:'bold',fontSize:'1vw',color:'#D32028',marginLeft:'0.3em'}}>{profileDetails ? <>&#8377;{formatNumberWithCommas(profileDetails?.courseFees)}</> : 'NA'}</span></span>
                  <span style={{whiteSpace:'nowrap'}}>Tenure : <span style={{fontWeight:'bold',fontSize:'16px',color:'#D32028'}}>{profileDetails?.loanTenure || '-'}</span></span>
                  <span style={{whiteSpace:'nowrap'}}>Dist. from CL : <span style={{fontWeight:'bold',fontSize:'16px',color:'#D32028'}}>{profileDetails?.location}</span></span>
                  {(() => {
                    const sourceStatus = location?.state?.dir || status;
                    if (!profileDetails || !sourceStatus) return null;
                    const actionItem = {
                      applicationId: currapplicationId,
                      userId: curruserId,
                      name: `${profileDetails?.firstName || ''} ${profileDetails?.lastName || ''}`.trim(),
                      ruleStatus: profileDetails?.ruleStatus ?? location?.state?.ruleStatus,
                      noBankStatement: profileDetails?.noBankStatement ?? location?.state?.noBankStatement,
                      noVerification: profileDetails?.noVerification ?? location?.state?.noVerification,
                      fundSourceCode: profileDetails?.fundSourceCode ?? location?.state?.fundSourceCode,
                      coapplicants: profileDetails?.coapplicants || [],
                      CRA: profileDetails?.cra || '',
                      cra: profileDetails?.cra || '',
                      instituteId: profileDetails?.instituteId || '',
                      courseFees: profileDetails?.courseFees,
                      mobile: profileDetails?.mobile || '',
                      channel: profileDetails?.channel,
                      instituteName: profileDetails?.instituteName || '',
                      firstName: profileDetails?.firstName || '',
                      lastName: profileDetails?.lastName || '',
                      email: profileDetails?.email || '',
                      emiFirstDate: sanctionEmiFirstDate || profileDetails?.emiFirstDate || '',
                    };
                    const goBack = () => {
                      dispatch(userActions.clearSearchStates());
                      navigate(-1);
                    };
                    const isRestrictedRole = ['institute_user', 'institute_admin', 'user', 'channel_user'].includes(decode?.role);
                    const componentMap = {
                      'In Submission': (
                        <>
                          {!isRestrictedRole && <EditForm curruser={actionItem} />}
                          {!isRestrictedRole && <MoveStatus ApplicantId={actionItem} onSuccess={goBack} />}
                          <ResendConsent userInfo={actionItem} />
                        </>
                      ),
                      'In Review':     (
                        <>
                          {!isRestrictedRole && <EditForm curruser={actionItem} />}
                          {!isRestrictedRole && <MoveReviewStatus ApplicantId={actionItem} onSuccess={goBack} />}
                          <SendSms userInfo={actionItem} />
                        </>
                      ),       
                      'In Process':      (
                        <>
                          {!isRestrictedRole && <EditForm curruser={actionItem} />}
                          {!isRestrictedRole && <MoveProcessingStatus ApplicantId={actionItem} onSuccess={goBack} />}
                          <SendSms userInfo={actionItem} />
                        </>
                      ),
                      'Pending Disbursement':<MovePendingStatus ApplicantId={actionItem} onSuccess={goBack} />,
                      'In Sanction':         <MoveSanctionStatus ApplicantId={actionItem} onSuccess={goBack} />,
                      'Ready to Disburse':   <MoveDisbursementStatus ApplicantId={actionItem} onSuccess={goBack} />,
                      'Rejected':            <MoveRejectedStatus ApplicantId={actionItem} onSuccess={goBack} />,
                      'On Hold':             <MoveOnHoldStatus ApplicantId={actionItem} onSuccess={goBack} />,
                      'Dropped':             <MoveDroppedStatus ApplicantId={actionItem} onSuccess={goBack} />,
                    };
                    const component = componentMap[sourceStatus];
                    if (!component) return null;
                    return (
                      <span style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '14px' }}>
                        <span style={{ fontWeight: 'bold', fontSize: '16px', color: '#667085' }}>Actions:</span>
                        {component}
                      </span>
                    );
                  })()}
                </div>
        {['In Sanction', 'Ready to Disburse'].includes(status) && (() => {
          const cardStyle = { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '5px', background: '#fff', border: '1px solid #eaecf0', borderRadius: '10px', padding: '7px 10px', minWidth: '60px', boxShadow: '0 1px 3px rgba(16,24,40,0.05)' };
          const statusColor = (s, passVals, failVals, initVals, warnVals) =>
            passVals.includes(s) ? '#12B76A' : failVals.includes(s) ? '#D22129' : initVals.includes(s) ? '#6E24E7' : warnVals.includes(s) ? '#F8A31F' : '#98a2b3';
          const digiColor = statusColor(integrationStatuses.digilockerStatus, ['Pass'], ['Failed'], ['Initiated'], ['Alert']);
          const selfieColor = statusColor(integrationStatuses.selfie, ['Pass'], ['Failed'], ['Initiated'], ['Face mismatch']);
          const agreeColor = statusColor(integrationStatuses.agreement, ['Signed', 'Manual', 'Regenerated'], [], ['Initiated'], ['Pending', 'Pending Coapplicant', 'Invalid']);
          const emColor = statusColor(integrationStatuses.emandate, ['Pass', 'Upi Mandate Done', 'Aadhaar Mandate Done'], ['Rejected', 'Aadhaar Mandate Failed', 'Upi Mandate Failed'], ['Initiated', 'Upi Mandate Initiated', 'Aadhaar Mandate Initiated'], ['Invalid Bank Details', 'Emandate Auth Success']);
          const fraudColor = integrationStatuses.applicantFraudCheck === 'pass' ? '#12B76A' : integrationStatuses.applicantFraudCheck === 'fail' ? '#D22129' : '#98a2b3';
          const pmtColor = integrationStatuses.paymentStatus === 'Paid' || integrationStatuses.paymentStatus === 'Paid At Institute' ? '#12B76A' : integrationStatuses.paymentStatus === 'Failed' ? '#D22129' : integrationStatuses.paymentStatus === 'Link Generated' ? '#F8A31F' : '#98a2b3';
          const Label = ({ color, text }) => (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', fontSize: '10px', fontWeight: '600', color, whiteSpace: 'nowrap' }}>
              <span style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: color, display: 'inline-block', flexShrink: 0 }} />
              {text}
            </span>
          );
          return (
            <div style={{ display: 'flex', alignItems: 'stretch', gap: '20px', marginTop: '10px', flexWrap: 'wrap' }}>
              <div style={{...cardStyle, cursor: 'pointer'}} title="DigiLocker" onClick={() => { if(['Pass','Initiated','Not Initiated','Alert','Skip'].includes(integrationStatuses.digilockerStatus)) modalRef.current.open('digilocker', {applicationId: currapplicationId, userId: curruserId, name: `${profileDetails?.firstName || ''} ${profileDetails?.lastName || ''}`.trim(), status: integrationStatuses.digilockerStatus}); }}>
                <IdCard size={22} strokeWidth={1.5} color={digiColor} />
                <Label color={digiColor} text={integrationStatuses.digilockerStatus === 'Pass' ? 'Pass' : integrationStatuses.digilockerStatus === 'Alert' ? 'Alert' : integrationStatuses.digilockerStatus === 'Failed' ? 'Failed' : integrationStatuses.digilockerStatus === 'Initiated' ? 'Init.' : integrationStatuses.digilockerStatus === 'Not Initiated' ? 'Not Init.' : integrationStatuses.digilockerStatus === 'Skip' ? 'Skip' : integrationStatuses.digilockerStatus || 'NA'} />
              </div>
              <div style={{...cardStyle, cursor: 'pointer'}} title="Selfie" onClick={() => modalRef.current.open('selfie', {applicationId: currapplicationId, userId: curruserId})}>
                <Camera size={22} strokeWidth={1.5} color={selfieColor} />
                <Label color={selfieColor} text={integrationStatuses.selfie === 'Pass' ? 'Pass' : integrationStatuses.selfie === 'Failed' ? 'Failed' : integrationStatuses.selfie === 'Initiated' ? 'Init.' : integrationStatuses.selfie === 'Face mismatch' ? 'Mismatch' : integrationStatuses.selfie || 'NA'} />
              </div>
              <div style={{...cardStyle, cursor: 'pointer'}} title="Agreement" onClick={() => modalRef.current.open('agreement', {applicationId: currapplicationId, userId: curruserId, status: integrationStatuses.agreement})}>
                <FileSignature size={22} strokeWidth={1.5} color={agreeColor} />
                <Label color={agreeColor} text={integrationStatuses.agreement === 'Signed' ? 'Signed' : integrationStatuses.agreement === 'Manual' ? 'Manual' : integrationStatuses.agreement === 'Regenerated' ? 'Regen.' : integrationStatuses.agreement === 'Pending' ? 'Pending' : integrationStatuses.agreement === 'Pending Coapplicant' ? 'Pend. CA' : integrationStatuses.agreement === 'Invalid' ? 'Invalid' : integrationStatuses.agreement === 'Initiated' ? 'Init.' : integrationStatuses.agreement || 'NA'} />
              </div>
              <div style={{...cardStyle, cursor: 'pointer'}} title="EMandate" onClick={() => modalRef.current.open('mandate', {applicationId: currapplicationId, userId: curruserId, name: `${profileDetails?.firstName || ''} ${profileDetails?.lastName || ''}`.trim(), status: integrationStatuses.emandate, cra: ''})}>
                <Landmark size={22} strokeWidth={1.5} color={emColor} />
                <Label color={emColor} text={integrationStatuses.emandate === 'Pass' ? 'Pass' : integrationStatuses.emandate === 'Upi Mandate Done' ? 'UPI Done' : integrationStatuses.emandate === 'Aadhaar Mandate Done' ? 'A Done' : integrationStatuses.emandate === 'Rejected' ? 'Rejected' : integrationStatuses.emandate === 'Aadhaar Mandate Failed' ? 'A Failed' : integrationStatuses.emandate === 'Upi Mandate Failed' ? 'UPI Failed' : integrationStatuses.emandate === 'Initiated' ? 'Init.' : integrationStatuses.emandate === 'Upi Mandate Initiated' ? 'UPI Init.' : integrationStatuses.emandate === 'Aadhaar Mandate Initiated' ? 'A Init.' : integrationStatuses.emandate === 'Invalid Bank Details' ? 'Attn!' : integrationStatuses.emandate === 'Emandate Auth Success' ? 'Auth OK' : (integrationStatuses.emandate === 'Not Initiated' || integrationStatuses.emandate === 'Aadhaar Mandate ToDo' || integrationStatuses.emandate === 'Upi Mandate ToDo') ? 'To Do' : integrationStatuses.emandate || 'NA'} />
              </div>
              {!(decode.role === 'institute_user' || decode.role === 'institute_admin' || decode.role === 'user' || decode.role === 'co_lender' || decode.role === 'channel_user') && (
                <div style={{...cardStyle, cursor: 'pointer'}} title="Fraud Detection" onClick={() => modalRef.current.open('fraud', {applicationId: currapplicationId, userId: curruserId, name: profileDetails?.name || ''})}>
                  <ShieldAlert size={22} strokeWidth={1.5} color={fraudColor} />
                  <Label color={fraudColor} text="Fraud" />
                </div>
              )}
              {!(decode.role === 'institute_user' || decode.role === 'institute_admin' || decode.role === 'user' || decode.role === 'co_lender' || decode.role === 'channel_user') && (
                <div style={{...cardStyle}} title="Payment Status">
                  <span style={{ fontSize: '12px', fontWeight: '700', color: pmtColor,marginBottom:'5px',marginTop:'5px' }}>PF</span>
                  <Label color={pmtColor} text={integrationStatuses.paymentStatus === 'Paid' || integrationStatuses.paymentStatus === 'Paid At Institute' ? 'Pmt Pass' : integrationStatuses.paymentStatus === 'Link Generated' ? 'Pmt Link Gen' : 'Pmt NA'} />
                </div>
              )}
              {status === 'Ready to Disburse' && !(decode.role === 'institute_user' || decode.role === 'institute_admin' || decode.role === 'user' || decode.role === 'co_lender' || decode.role === 'channel_user') && (
                <div style={{...cardStyle, cursor: isLoadingDisbursement ? 'not-allowed' : 'pointer', backgroundColor: '#D32028', opacity: isLoadingDisbursement ? 0.7 : 1}} title="Create Disbursement" onClick={() => !isLoadingDisbursement && handlePayouts(currapplicationId)}>
                  {isLoadingDisbursement ? (
                    <CircularProgress size={24} sx={{ color: 'white' }} />
                  ) : (
                    <>
                      <span style={{ fontSize: '11px', fontWeight: '700', color: 'white', textAlign: 'center' }}>Create</span>
                      <Label color='white' text="Disbursement" />
                    </>
                  )}
                </div>
              )}
            </div>
          );
        })()}
              </div>
            </div>


            <Modal isOpen={modal}  size="xl" style={{height:'100%'}}>
        <ModalHeader toggle={toggle1}>Agreement</ModalHeader>
        <ModalBody >
        <iframe
            src={agreementUrl}
            width="100%"
            height="1000vh"
            style={{ border: 'none' }}
          ></iframe>
        </ModalBody>
        
      </Modal>
      <Modal isOpen={sanctionModal}  size="xl" style={{height:'100%'}}>
        <ModalHeader toggle={toggleSanction}>Sanction Letter</ModalHeader>
        <ModalBody >
        <iframe
            src={sanctionUrl}
            width="100%"
            height="1000vh"
            style={{ border: 'none' }}
          ></iframe>
        </ModalBody>
       
       
      </Modal>

      <DisbursementModal
        isOpen={selectedStatusOpen}
        onClose={() => setSelectedStatusOpen(false)}
        displaySelected={displaySelected}
        selectedName={selectedName}
        applicationId={displaySelected?.applicationId}
        user={user}
        onSuccess={() => navigate(-1)}
      />

      <IntegrationModals ref={modalRef} user={user} decode={decode} onActionComplete={() => window.location.reload()} />

            <div style={{display:'flex',justifyContent: 'space-evenly',alignItems:'center', width:'20em',height:'3em',marginTop:'-5em'}}>
              <Button
            onClick={handleOpenDialog}
            style={{
              color: "white",
              cursor: "pointer",
              fontSize: "16px", 
              width: "100px",
              backgroundColor: "#d32028",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderColor: "#d32028",
              padding: "4px 8px",
              marginBottom: "5px",
              marginRight:'20px',
              textTransform: 'none'
            }}
          >
          <img
            style={{ marginRight: "5px", width: "16px", height: "16px" }} // Scaled properly
            src={ActivityLogo}
            alt="activity"
          />
          Activity
        </Button>


      <Dialog
        fullScreen
        open={isDialogOpen}
        onClose={handleCloseDialog}
        TransitionComponent={Transition}
        PaperProps={{
          sx: {
            width: "50%",
            maxWidth: "80vw",
            height: "100vh",
            ml: "auto",
            borderTopLeftRadius: "15px",
            borderBottomLeftRadius: "15px",
          },
        }}
      >
        <DialogContent>
          <Activity />
        </DialogContent>
      </Dialog>

      {/* confirmation modal for removing co-applicant */}
      <Dialog
        open={isRemoveDialogOpen}
        onClose={() => setIsRemoveDialogOpen(false)}
      >
        <DialogTitle sx={{ fontWeight: 'bold' }}>Confirm Removal</DialogTitle>
        <DialogContent>
          Are you sure you want to remove this co-applicant?
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between' }}>
          <Button onClick={() => setIsRemoveDialogOpen(false)}>Cancel</Button>
          <Button
            onClick={confirmRemoveCoapplicant}
            bgcolor="#d32028"
            variant="contained"
          >
            Remove
          </Button>
        </DialogActions>
      </Dialog>

      {/* modal showing result of removal attempt */}
      <Dialog
        open={removeStatus.open}
        onClose={() => setRemoveStatus(prev => ({ ...prev, open: false }))}
      >
        <DialogTitle sx={{ fontWeight: 'bold' }}>
          {removeStatus.severity === 'success' ? 'Success' : 'Error'}
        </DialogTitle>
        <DialogContent>{removeStatus.message}</DialogContent>
        <DialogActions>
          <Button
            onClick={() => setRemoveStatus(prev => ({ ...prev, open: false }))}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

              <Dropdown style={{marginBottom:'0.5em'}}  isOpen={documentToggle} toggle={() => handleDocToggle()}>
                   <DropdownToggle caret style={{backgroundColor:'#d32028',border:'none',height:'35px', }}>
                          Documents
                  </DropdownToggle>
                       <DropdownMenu >
                          <DropdownItem disabled={bankSelfieData?.agreementUrl?false:true} >
                          <div onClick={toggle1}>Agreement</div>
                      </DropdownItem>
                          <DropdownItem disabled={bankSelfieData?.sanctionLetter?false:true} >
                          <div  target="_blank" rel="noreferrer" onClick={toggleSanction}>Sanction Letter</div>
                      </DropdownItem>
                        </DropdownMenu>
                </Dropdown>
            
              
            </div>
            
          </div>
          <div style={{display:'block',backgroundColor:'#F8F8F8',border:'none',borderRadius:'1em',boxShadow:'0px 2px 2px 0px #C0C0C0',height:'100%',marginLeft:'1%',marginRight:'1%',padding:'2em'}}>
            <div style={{display:'flex',justifyContent: 'space-between'}}>
                <div style={{display:'block',lineHeight:'18px',width:'12em'}}>
                <p className='field-title'>Email Id</p>
                <p>{profileDetails?.email}</p>
              </div>
              <div style={{display:'block',lineHeight:'18px',width:'12em'}}>
                <p  className='field-title'>Phone Number</p>
                <p>{profileDetails?.mobile}<span>{(profileDetails?.whatsappNumber === profileDetails?.mobile)?<a title='whatsApp' href={`https://wa.me/+91${profileDetails?.whatsappNumber}`} target="_blank" rel="noreferrer">
                <WhatsAppIcon  style={{ color:"black",cursor:'pointer',height:'2rem',marginLeft:'0.5rem'}}/>
                </a>:null}</span></p>
                 {(profileDetails?.whatsappNumber && profileDetails?.mobile && 
                  profileDetails.whatsappNumber !== profileDetails.mobile) ? (
                  <div>
                    <p>
                      {profileDetails.whatsappNumber}
                      <span>
                        <a 
                          title="WhatsApp" 
                          href={`https://wa.me/+91${profileDetails.whatsappNumber}`} 
                          target="_blank" 
                          rel="noreferrer"
                        >
                          <WhatsAppIcon 
                            style={{ 
                              color: "black",
                              cursor: 'pointer',
                              height: '2rem',
                              marginLeft: '0.5rem'
                            }}
                          />
                        </a>
                      </span>
                    </p>
                  </div>
                ) : null}
              </div>
              {decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? <div style={{display:'block',lineHeight:'18px',width:'12em'}}>
                <p  className='field-title'>Applicant Name</p>
                <p>{profileDetails?.firstName + " " + profileDetails?.lastName}</p>
              </div>:
              <div style={{display:'block',lineHeight:'18px',width:'12em'}}>
                <p  className='field-title'>Student Name</p>
                <p>{profileDetails?.studentName}</p>
              </div>}
              {decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && <div style={{display:'block',lineHeight:'18px',width:'12em'}}>
                <p  className='field-title'>Father Name</p>
                <p>{profileDetails?.fatherName ? profileDetails?.fatherName : '---'}</p>
              </div>
              }
              <div style={{display:'block',lineHeight:'18px' ,width:'13em',height:'6em' }}>
                 <p  className='field-title'>Ref Phone Number</p>
          <ContactSlider foirRefData={foirRefData}/>
              </div>
            </div>
            <div style={{display:'flex',justifyContent: 'space-between',paddingTop:'1.5em',paddingBottom:'1.5em'}}>
              <div style={{display:'block',lineHeight:'18px',width:'12em'}}>
                <p  className='field-title'>Date of Birth</p>
                <p>{moment(profileDetails?.dateOfBirth).format('DD MMM YYYY')}({age}yrs)</p>
              </div>
              <div style={{display:'block',lineHeight:'18px',width:'12em'}}>
                <p  className='field-title'>PAN Number</p>
                <p>{profileDetails?.panId}</p>
              </div>
              {
                decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'? 
                    <div style={{display:'block',lineHeight:'18px',width:'12em'}}>
                    <p  className='field-title'>Product Type</p>
                    <p >{profileDetails?.instituteName}</p>
                  </div>:
                  <div style={{display:'block',lineHeight:'18px',width:'12em'}}>
                  <p  className='field-title'>Course</p>
                  <p >{profileDetails?.courseName}</p>
                </div>
              }
              {
                decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'? 
                    <div style={{display:'block',lineHeight:'18px',width:'12em'}}>
                    <p  className='field-title'>Client</p>
                    <p >Not available</p>
                  </div>:
                  <div style={{display:'block',lineHeight:'18px',width:'13em'}}>
                  <p  className='field-title'>Institute</p>
                  <p style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    {profileDetails?.instituteName}
                    {profileDetails?.instituteNotes ? (
                      <Tooltip
                        arrow
                        placement="top"
                        PopperProps={{
                          modifiers: [
                            {
                              name: 'offset',
                              options: {
                                offset: [0, 6],
                              },
                            },
                          ],
                        }}
                        title={
                          <div style={{ maxWidth: 380, padding: '6px 8px'  }}>
                            <div style={{ fontWeight: 800, marginBottom: 4,fontSize:13,color: '#fff', opacity: 0.95}}>Credit Policy</div>
                            <div style={{ whiteSpace: 'pre-wrap', fontSize: 13,lineHeight: 1.3,color: '#fff',opacity: 0.9,borderTop: '1px solid rgba(255,255,255,0.08)',paddingTop: 6 }}>{profileDetails.instituteNotes}</div>
                          </div>
                        }
                      >
                        <img
                          src={info}
                          alt="info"
                          style={{ height: 20, width: 20, marginLeft: 5, cursor: 'pointer' }}
                        />
                      </Tooltip>
                    ) : null}
                  </p>
                </div>
              }
             
              
            
              
            </div>

            {/* businees loan type entity details begin */}
            { profileDetails?.instituteName === 'Business Loan' && (<>
            <div style={{display:'flex',justifyContent: 'space-between'}}>
            <div style={{display:'block',lineHeight:'18px',width:'36em'}}>
            <p><span style={{color:'#D32038',fontWeight:'bold'}}>Business Entity Name</span>
           </p>
           <p> <span>{profileDetails?.entityName ? profileDetails?.entityName : '---'}</span></p>
            </div>

            <div style={{display:'block',lineHeight:'18px',width:'12em'}}>
                <p  className='field-title'>Business Entity Type</p>
                <p>{profileDetails?.entityType ?profileDetails?.entityType: '---'}</p>
              </div>
              <div style={{display:'block',lineHeight:'18px',width:'12em'}}>
                <p  className='field-title'>Business Entity annualTurnoverRange</p>
                <p>{profileDetails?.entityAnnualTurnoverRange? profileDetails?.entityAnnualTurnoverRange : '---'}</p>
              </div>
              <div style={{display:'block',lineHeight:'18px',width:'13em'}}>
                <p  className='field-title'>Business Entity GST Numb</p>
                <p>{profileDetails?.gstNumber ?profileDetails?.gstNumber: '---'}</p>
              </div>
            </div>
            </>)
            }

            {/* end */}

            <div style={{display:'flex',justifyContent: 'space-between'}}>
            <div style={{display:'block',lineHeight:'18px',width:'36em'}}>
            <p><span style={{color:'#D32038',fontWeight:'bold'}}>Current Address</span>
           </p>
           <p> <span>{profileDetails?.currentAddress}</span></p>
            </div>

            <div style={{display:'block',lineHeight:'18px',width:'12em'}}>
                <p  className='field-title'>Current City</p>
                <p>{profileDetails?.currentCity}</p>
              </div>
              <div style={{display:'block',lineHeight:'18px',width:'12em'}}>
                <p  className='field-title'>Current State</p>
                <p>{profileDetails?.currentState}</p>
              </div>
              <div style={{display:'block',lineHeight:'18px',width:'13em'}}>
                <p  className='field-title'>Current Pincode</p>
                <p>{profileDetails?.currentPincode}</p>
              </div>
            </div>
            
            <div style={{display:'flex',justifyContent:'flex-end',lineHeight:'18px'}}>
              <img src={pencil} onClick={()=>setEditModal(true)} title="Edit" style={{width:'1.4rem',height:'1.3rem',cursor:'pointer',marginTop:'0.4rem'}}/>
              <a title='whatsApp' href={`https://wa.me/+91${profileDetails?.mobile}`} target="_blank" rel="noreferrer">
                        <WhatsAppIcon  style={{ color:"black",cursor:'pointer',marginLeft:'1em',height:'2rem'}}/>
                        </a>
              </div>
            
            {/* <div style={{lineHeight:'18px',width:'12em',paddingLeft:'1.5em'}}>

                <p  style={{color:'#D32038',fontWeight:'bold'}}>Current Address</p>
                <p title={profileDetails?.currentAddress} >{profileDetails?.currentAddress?.length>30?profileDetails?.currentAddress?.substr(0,40)+"...":profileDetails?.currentAddress}</p>
              </div> */}
           
           
          </div>
          <div style={{paddingLeft: '1em',paddingRight:'1em',marginTop:'1em'}}>
           <Nav tabs >
              {(decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ||profileDetails?.instituteName==='Mortgage Loan' || profileDetails?.instituteName==='Loan Against Securities' ) && <NavItem style={{backgroundColor:activeTab === '0' ? '#fff2f2' : '#fff'}}>
                <NavLink
                 style={{textDecoration:'none',borderBottom: activeTab === '0' ? '2px solid #D32028' : ''}}
                  className={activeTab === '0' ? 'active bg-transparent' : 'cursor-pointer'}
                  onClick={() => {
                    toggle('0');
                  }}
                >
                <span  className={activeTab === '0' ? 'tabsHeadingClicked' : 'tabsHeading'}>End Use</span>

                </NavLink>
              </NavItem>}
              <NavItem style={{backgroundColor:activeTab === '1' ? '#F8F8F8' : '#fff',}}>
                <NavLink
                 style={{textDecoration:'none',borderBottom: activeTab === '1' ? '2px solid #D32028' : '', }}
                  className={activeTab === '1' ? 'active bg-transparent' : 'cursor-pointer'}
                  onClick={() => {
                    toggle('1');
                  }}
                >
                <span  className={activeTab === '1' ? 'tabsHeadingClicked' : 'tabsHeading'}>Files</span>

                </NavLink>
              </NavItem>

              <NavItem style={{backgroundColor:activeTab === '2' ? '#fff2f2' : '#fff'}}>
                <NavLink
                style={{textDecoration:'none',borderBottom: activeTab === '2' ? '2px solid #D32028' : ''}}
                  className={activeTab === '2' ? 'active bg-transparent' : 'cursor-pointer'}
                  onClick={() => {
                    
                    toggle('2');
                  }}>
                  <span  className={activeTab === '2' ? 'tabsHeadingClicked' : 'tabsHeading'} >KYC Profile</span>
                </NavLink>
              </NavItem>
              {decode?.clientId!=='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && <NavItem style={{backgroundColor:activeTab === '3' ? '#fff2f2' : '#fff'}}>
                <NavLink
                style={{textDecoration:'none',borderBottom: activeTab === '3' ? '2px solid #D32028' : ''}}
                  className={activeTab === '3' ? 'active bg-transparent' : 'cursor-pointer'}
                  onClick={() => {
                     
                    toggle('3');
                  }}
                >
                  <span  className={activeTab === '3' ? 'tabsHeadingClicked' : 'tabsHeading'}>Experian</span>
                </NavLink>
              </NavItem>
              }
              <NavItem style={{backgroundColor:activeTab === '4' ? '#fff2f2' : '#fff'}}>
                <NavLink
                style={{textDecoration:'none',borderBottom: activeTab === '4' ? '2px solid #D32028' : ''}}
                  className={activeTab === '4' ? 'active bg-transparent' : 'cursor-pointer'}
                  onClick={() => {
                     
                    toggle('4');
                  }}
                >
                  <span  className={activeTab === '4' ? 'tabsHeadingClicked' : 'tabsHeading'}>Credit Profile</span>
                </NavLink>
              </NavItem>
              <NavItem style={{backgroundColor:activeTab === '5' ? '#fff2f2' : '#fff'}}>
                <NavLink
                style={{textDecoration:'none',borderBottom: activeTab === '5' ? '2px solid #D32028' : ''}}
                  className={activeTab === '5' ? 'active bg-transparent' : 'cursor-pointer'}
                  onClick={() => {
                    toggle('5');
                  }}
                >
                  <span  className={activeTab === '5' ? 'tabsHeadingClicked' : 'tabsHeading'}>{`${decode?.clientId !== "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" ? "Income" : "Banking"} Profile (PDF)`}</span>
                </NavLink>
              </NavItem>
              <NavItem style={{backgroundColor:activeTab === '6' ? '#fff2f2' : '#fff'}}>
                <NavLink
                style={{textDecoration:'none',borderBottom: activeTab === '6' ? '2px solid #D32028' : ''}}
                  className={activeTab === '6' ? 'active bg-transparent' : 'cursor-pointer'}
                  onClick={() => {
                    toggle('6');
                  }}
                >
                  <span  className={activeTab === '6' ? 'tabsHeadingClicked' : 'tabsHeading'}>{`${decode?.clientId !== "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" ? "Income" : "Banking"} Profile (AA)`}</span>
                </NavLink>
              </NavItem>
            <NavItem style={{backgroundColor: activeTab === '7' ? '#fff2f2' : '#fff'}}>
              <NavLink
                style={{
                  textDecoration: 'none',
                  borderBottom: activeTab === '7' ? '2px solid #D32028' : '',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
                className={activeTab === '7' ? 'active bg-transparent' : 'cursor-pointer'}
                onClick={() => {
                  toggle('7');
                }}
              >
                <span className={activeTab === '7' ? 'tabsHeadingClicked' : 'tabsHeading'}>
                  Rules
                </span>
                {rules?.result?.result?.overall === "green" ? (
                  <svg width="30" height="30" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="50" cy="50" r="40" fill="#e6f7e6" />
                    <circle cx="50" cy="50" r="30" fill="#4CAF50" />
                    <path d="M35,50 L45,65 L70,35" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                  </svg>
                ) : rules?.result?.result?.overall === "orange" ? (
                  <svg width="30" height="30" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="50" cy="50" r="40" fill="#fff3e0" />
                    <circle cx="50" cy="50" r="30" fill="#FF9800" />
                    <path d="M50,35 L50,55" stroke="white" strokeWidth="6" strokeLinecap="round" />
                    <circle cx="50" cy="65" r="3" fill="white" />
                  </svg>
                ) : rules?.result?.result?.overall === "red" ? (
                  <svg width="30" height="30" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="50" cy="50" r="40" fill="#ffebee" />
                    <circle cx="50" cy="50" r="30" fill="#F44336" />
                    <path d="M35,35 L65,65 M35,65 L65,35" stroke="white" strokeWidth="6" strokeLinecap="round" />
                  </svg>
                ) : null}
              </NavLink>
            </NavItem>  
             {decode?.clientId !== "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" &&<NavItem style={{backgroundColor:activeTab === '8' ? '#fff2f2' : '#fff'}}>
                <NavLink
                style={{textDecoration:'none',borderBottom: activeTab === '8' ? '2px solid #D32028' : ''}}
                  className={activeTab === '8' ? 'active bg-transparent' : 'cursor-pointer'}
                  onClick={() => {
                    toggle('8');
                  }}
                >
                  <span  className={activeTab === '8' ? 'tabsHeadingClicked' : 'tabsHeading'}>Monk AI</span>
                </NavLink>
              </NavItem>} 
                {decode?.clientId !== "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" && <NavItem style={{backgroundColor:activeTab === '9' ? '#fff2f2' : '#fff'}}>
                <NavLink
                style={{textDecoration:'none',borderBottom: activeTab === '9' ? '2px solid #D32028' : ''}}
                  className={activeTab === '9' ? 'active bg-transparent' : 'cursor-pointer'}
                  onClick={() => {
                    toggle('9');
                  }}
                >
                  <span  className={activeTab === '9' ? 'tabsHeadingClicked' : 'tabsHeading'}>Notification Report</span>
                </NavLink>
              </NavItem>}
            </Nav>
           
            <TabContent activeTab={activeTab}>
              <TabPane tabId="0">
                  <Row>
                    <Col  sm="12">
                      <LoanDetails profileDetails={profileDetails} shouldFetchData={!isInSubmission}/>
                    </Col>
                  </Row>
                </TabPane>
              <TabPane tabId="1">
                <Row>
                  <Col  sm="12">
                  {visitedTabs['1'] && (
                    <Files appId={currapplicationId} userId={curruserId} profileDetails={profileDetails}/>
                  )}
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="2">
                <Row>
                  <Col sm="12" >
                  {visitedTabs['2'] && (
                    <KycProfile 
                      profileDetails={profileDetails} 
                      curruserId={curruserId} 
                      currapplicationId={currapplicationId}
                      shouldFetchData={!isInSubmission}
                    />
                  )}                  
                </Col>
                </Row>
              </TabPane>
              <TabPane tabId="3">
                <Row>
                  <Col sm="12" >
                   {visitedTabs['3'] && (
                   <PreScreen userId={curruserId} applicationId={currapplicationId} shouldFetchData={!isInSubmission}/>
                    )}
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="4">
                <Row>
                  <Col sm="12">
                   {visitedTabs['4'] && (
                      <CreditProfile 
                        profileDetails={profileDetails} 
                        curruserId={curruserId}
                        appId={currapplicationId}
                        shouldFetchData={!isInSubmission}
                      />
                    )}
                  </Col>
                </Row>
              </TabPane>
               <TabPane tabId="5">
                <Row style={{ width: 'auto' }}>
                  <Col sm="12">
                  {visitedTabs['5'] && (
                      <IncomeProfile profileDetails={profileDetails} foirRefData={foirRefData} userId={curruserId} appId={currapplicationId} isCoapplicant={isCoapplicantProfile} />
                   )} 
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="6">
                <Row style={{ width: 'auto' }}>
                  <Col sm="12">
                  {visitedTabs['6'] && (
                      <AccountAggregator profileDetails={profileDetails} foirRefData={foirRefData} userId={curruserId} appId={currapplicationId} isCoapplicant={isCoapplicantProfile} />
                  )} 
                    </Col>
                </Row>
              </TabPane>
              <TabPane tabId="7">
                <Row style={{ width: 'auto' }}>
                  <Col sm="12">
                  {visitedTabs['7'] && (
                  <ReactFlowProvider>
                   <LayoutFlow userId={curruserId} appId={currapplicationId} shouldFetchData={!isInSubmission}/>
                  </ReactFlowProvider>
                  )}
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="8">
                <Row style={{ width: 'auto' }}>
                  <Col sm="12">
                  {visitedTabs['8'] && (
                    <MonkCibilAi applicant_id={curruserId} applicationId={currapplicationId} shouldFetchData={!isInSubmission}/>
                     )} 
                  </Col>
                </Row>
              </TabPane>
              {decode?.clientId !== '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' &&(<>
              <TabPane tabId="9">
                <Row style={{ width: 'auto' }}>
                  <Col sm="12">
                  {visitedTabs['9'] && (
                    <NotificationReport profileDetails={profileDetails} userId={curruserId} applicationId={currapplicationId} />
                     )} 
                  </Col>
                </Row>
              </TabPane></>)}

            </TabContent>
             </div>
  </Card>
  </>
  )
}
